<template>
  <div>
    <LoadingView :loading="isLoading" class="max-w-[75%]">
      <FormKit
        v-if="resources.length > 0"
        v-model="selectedPortfolio"
        type="qselect"
        :options="resources"
        label-by="fio"
        track-by="id"
        placeholder="Выберите портфолио"
        help="Вы можете заполнить портфолио вручную"
      >
        <template #item="{ option }">
          <span v-text="`${option.fio} (ID: ${option.id})`" />
        </template>
      </FormKit>

      <LoadingView :loading="!showForm" class="mt-8">
        <FormKit v-model="model" type="form" :actions="false">
          <FormKitSchema :schema="transformedSchema" />
        </FormKit>
      </LoadingView>
    </LoadingView>
  </div>
</template>

<script setup>
import { find } from 'lodash-es'
import { computed, inject, ref, watch } from 'vue'

import LoadingView from '@/components/loading/LoadingView.vue'
import { schema, transformData } from '@/utils/portfolio-scheme.js'

const http = inject('http')
const isLoading = ref(true)
const resources = ref({})
const showForm = ref(true)

const props = defineProps({
  context: {
    type: Object,
  },
  passed: {
    type: Boolean,
  },
  current: {
    type: Boolean,
  },
  modelValue: {},
})

const selectedPortfolio = ref(null)

const emits = defineEmits(['update:model-value', 'loading'])

const model = computed({
  get: () => {
    return props.modelValue ?? []
  },
  set: (val) => {
    emits('update:model-value', val)
  },
})

const transformedSchema = computed(() => {
  return schema.map((i) => {
    i.required = true
    i.readonly = !!selectedPortfolio.value
    i.disabled = !!selectedPortfolio.value

    if (i.children) {
      i.children = i.children.map((j) => {
        j.required = true
        j.readonly = !!selectedPortfolio.value
        j.disabled = !!selectedPortfolio.value

        return j
      })
    }

    return i
  })
})

http('/profile/children')
  .then(({ resources: r }) => {
    resources.value = r
  })
  .finally(() => (isLoading.value = false))

watch(
  () => selectedPortfolio.value,
  () => {
    showForm.value = false

    const portfolio = find(resources.value, ['id', selectedPortfolio.value])

    if (portfolio) {
      model.value = {
        ...transformData(portfolio),
      }
    } else {
      model.value = {}
    }

    setTimeout(() => {
      showForm.value = true
    }, 300)
  },
)
</script>
